export const cilFullscreenExit = ["24 24","<path d='M9.563 8.502l-7.752-7.752h-1.061v1.061l7.752 7.752h-6.439v1.5h9v-9h-1.5v6.439z'></path><path d='M15.311 14.25h6.439v-1.5h-9v9h1.5v-6.439l7.939 7.939h1.061v-1.061l-7.939-7.939z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-fullscreen-exit.js
// module id = null
// module chunks = 